import React from "react";

import tracking from "../../utils/tracking";
import {
  HEADER_COPY,
  BODY_COPY,
  CTA_COPY,
  CTA_LINK,
  IMAGE
} from "../../utils/content-keys";
import Hero from "../../components/Hero";

const VisitUsHero = ({ content, introContent }) => {
  return (
    <Hero className="VisitUsPage__hero row no-gutters" fullWidth={false}>
      <div className="col-md-6" style={{ zIndex: 1 }}>
        <div className="VisitUsPage__hero-panel">
          <h2 className="VisitUsPage__hero-panel-headline">
            {content[HEADER_COPY].value}
          </h2>
          <p
            className="VisitUsPage__hero-panel-copy"
            dangerouslySetInnerHTML={{
              __html: content[BODY_COPY].value.replace(
                /\*\*([^*]+)\*\*/g,
                '<span class="VisitUsPage__hero-panel-copy--lg">$1</span>'
              )
            }}
          />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={content[CTA_LINK].value}
            className="cta cta--red VisitUsPage__hero-panel-cta"
            onClick={() =>
              tracking.event("customEvent", {
                eventCategory: "Google Maps",
                eventAction: "click",
                eventLabel: "Visit us page"
              })
            }
          >
            {content[CTA_COPY].value}
          </a>
        </div>
      </div>
      <div
        className="col-md-6 d-none d-md-block VisitUsPage__hero-image-wrapper"
        style={{ zIndex: 2 }}
      >
        <img
          className="VisitUsPage__hero-image"
          src={content[IMAGE].length?content[IMAGE][0].imgURL:content[IMAGE].imgURL}
          alt={content[IMAGE].value}
        />
      </div>
      <div className="VisitUsPage__panel-bottom">
        <img
          src={content[IMAGE].length?content[IMAGE][1].imgURL:content[IMAGE].imgURL}
          alt={content[IMAGE].value}
          className="VisitUsPage__panel-bottom-image d-md-none"
        />
        <h3 className="VisitUsPage__panel-bottom-headline">
          {introContent[HEADER_COPY].value}
        </h3>
        <p className="VisitUsPage__panel-bottom-copy">
          {introContent[BODY_COPY].value}
        </p>
      </div>
    </Hero>
  );
};

export default VisitUsHero;



// WEBPACK FOOTER //
// ./src/pages/visitus/visit-us-hero.js